import podsStyles from "../sass/pods";
import BasicContent from "./basic-content";
import blog from "./blog";
import blogComment from "./blog/comments";
import PrimaryFeature from "./primary-feature";
import PrimaryFeatureCtaBanner from "./primary-feature-cta-banner";
import ImageRow from "./image-row";
import LogoRow from "./logo-row";
import SplitImage from "./split-components/split-image";
import SplitMedia from "./split-components/split-media";
import SplitCarousel from "./split-components/split-carousel";
import SplitStaticList from "./split-components/split-static-list";
import SplitItems from "./split-components/split-items";
import StateList from "./location-components/state-list";
import LocationList from "./location-components/locations-list"
import CityList from "./location-components/city-list";
import NumberRow from "./number-row";
import ButtonRow from "./button-row";
import Breadcrumb from "./breadcrumb";
import primaryAction from "./primary-action";
import quoteFlowWidget from "./quote-flow/Code/QuoteFlowForm/QuoteFlowWidget";
import quoteFlowFormLoader from "./quote-flow/Code/QuoteFlowForm/components/QuoteFlowFormLoader";
import QuoteFlowStyles from "./quote-flow/Code/QuoteFlowForm/QuoteFlowForm";
import quoteFlowHeroWidget from "./quote-flow-hero-widget";
import TitleComponent from "./title";
import Modal from "./globals/modal";
import TileSlider from "./tile-slider";
import IFrame from "./iframe-container";
import AlertBar from "./alert-bar";
import CookiesConsent from "./cookies-consent";
import SiteMap from "./sitemap";
import ContentGrid from "./content-grid";
import PreviousQuote from "./previous-quote";
import ContainerDisplay from "./container-display";
import OrderConfirmation from "./order-confirmation";
import errorPageStyles from "./error-page/500-error-page";
import CityLocationsMap from "./location-components/city-locations-map";
import OtherCities from "./location-components/other-cities";
import IFMoveThankYou from "./IF-move-thank-you";
import BackToTopButton from "./back-to-top-button";
import IconCarouselRow from "./icon-carousel-row";
import QuickLinks from "./quicklinks";
import CityService from "./city-service";
import SolutionFinder from "./solution-finder";
import Accordion from "./accordion";
import ContainerSizeSuggester from "./container-size-suggester";
import IFPriceDisplay from "./if-price-display";
import Gatherup from "./gatherup";
import CaliforniaPrivacyForm from "./california-privacy-form";
import PromoBanner from "./promo-banner";
import SalesforceForms from "./salesforce-forms";
import EngagementBanner from "./engagement-banner";
import TermsAndAgreement from "./terms-and-agreement";
import cardCarouselStyle from "./card-carousel";
import tabbedFeature from "./tabbed-feature";
import contentCarousel from "./content-carousel";
import widget from "./widget";
import blogCarousel from "./blog-carousel";
import socialMediaFix from "./blog/social-media";
import BookingFlowComponents from './booking-flow-components';

document.addEventListener("DOMContentLoaded", function(event) {
  window.podsPage = new PodsPage();
  $(".modal__closer").on("click", function(){
    $("body").removeClass("modal__open");
  })
});

class PodsPage {
  constructor() {
    this.modal = new Modal();
    this.cityMap = new CityLocationsMap();
    const cityService = new CityService();
    window.addEventListener("resize", this.resizeBodyContent.bind(this));
    this.resizeBodyContent();
  }

  resizeBodyContent = () => {
    const mainContentEl =
      document.getElementById("main-container") ||
      document.getElementById("minimal-main-container");

    if (mainContentEl) {
      mainContentEl.style.minHeight = this.getBodyMinHeight();
    }
  };

  getBodyMinHeight = () => {
    const headerEl = document.querySelector("header");
    const footerEl = document.querySelector("footer");
    let offsetHeight = 0;

    if (headerEl) {
      const headerStyle = window.getComputedStyle(headerEl);
      if (headerStyle.position !== "fixed") {
        offsetHeight += headerEl.offsetHeight;
      }
    }

    if (footerEl) {
      offsetHeight += footerEl.offsetHeight;
    }

    return `calc(100% - ${offsetHeight}px)`;
  };
}
(function ($) {
  if($("input.selected-date-picker").length){
    $("input.selected-date-picker").on('click',function(){ $(this).focus().blur();});
  }
}(jQuery));
